import { action } from '@ember/object';
import type Owner from '@ember/owner';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import didUpdate from 'webapp/modifiers/did-update';
import ReportsViewerSlideInnerComponent from 'webapp/components/reports/viewer/slide-inner';

import type ReportSlide from 'webapp/models-custom/report-slide';

export interface Args {
	model: ReportSlide;
	onBoardPreviewHashChange?: (boardId: string, previewHash?: string | null) => void;
}

interface ReportsViewerSlideOuterComponentInterface<T> {
	Args: T;
	Blocks: { default: [] };
}

export default class ReportsViewerSlideOuterComponent<T extends Args> extends Component<
	ReportsViewerSlideOuterComponentInterface<T>
> {
	@tracked isLoadingBlocks = true;

	constructor(owner: Owner, args: T) {
		super(owner, args);

		this.onModelChange();
	}

	@action
	handleModelChangeEvent() {
		this.onModelChange();
	}

	@action
	onModelChange(_isInitialCheck = false): void {
		const model = this.args.model;

		// request all blocks & data-selects on slide, bcos we need them for rendering
		const blockPromises = model.getBlockPromises();

		if (blockPromises.length) {
			this.isLoadingBlocks = true;
			void Promise.allSettled(blockPromises).then(() => {
				this.isLoadingBlocks = false;
			});
		} else {
			this.isLoadingBlocks = false;
		}
	}
	<template>
		<div
			class="report_slide_ct"
			data-id={{@model.id}}
			{{didUpdate this.handleModelChangeEvent @model.board}}
		>
			<ReportsViewerSlideInnerComponent>
				{{yield}}
			</ReportsViewerSlideInnerComponent>

		</div>
	</template>
}
